export default __webpack_public_path__ + "static/media/CA-7 Admin API Integration.391a3b35.png";